import { DateTime } from "schema-dts";
import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";
import type { Organisation } from "services/cms/models/organisation";
import type { Person } from "services/cms/models/person";
import type { ResolvedImage } from "./imageResolver";
import type { ResolvedOrganisation } from "./organisationResolver";
import organisationResolver from "./organisationResolver";
import type { ResolvedPerson } from "./personResolver";
import personResolver from "./personResolver";

export interface ResolvedAuthor {
    authorProfileUrl?: string;
    description?: string;
    image?: ResolvedImage;
    jobTitle?: string;
    knowsAbout?: string;
    name: string;
    lengthOfServiceDisplayText?: string;
    type: ResolvedPerson["type"] | ResolvedOrganisation["type"];
}

const authorResolver = (data: Person | Organisation): ResolvedAuthor => {
    switch (data.system.type) {
        case ContentTypeCodenames.Person:
            const person = personResolver(data as Person);

            let totalYears = undefined;
            let lengthOfServiceText = "";
            if (person.startDate != null) {
                const now = new Date();
                const startDateObj = new Date(person.startDate);
                const totalYearsMs = now.getTime() - startDateObj.getTime();
                const year = new Date(totalYearsMs).getUTCFullYear();
                totalYears = Math.abs(year - 1970);
                if (totalYears > 1) {
                    lengthOfServiceText = `${totalYears} years with Motorpoint`;
                } else if (totalYears == 1) {
                    lengthOfServiceText = `${totalYears} year with Motorpoint`;
                } else {
                    lengthOfServiceText = "Less than 1 year with Motorpoint";
                }
            }

            return {
                description: person.bio,
                image: person.avatar,
                jobTitle: person.jobTitle,
                lengthOfServiceDisplayText: lengthOfServiceText,
                name: person.name,
                type: person.type,
                knowsAbout: person.knowsAbout,
            };

        case ContentTypeCodenames.Organisation:
            const organisation = organisationResolver(data as Organisation);

            return {
                description: organisation.description,
                image: organisation.logo,
                name: organisation.name,
                type: organisation.type,
            };

        default:
            throw Error(`Unsupported type provided (${data.system.type})`);
    }
};

export default authorResolver;
